import { Component } from '@angular/core';

@Component({
  selector: 'toyota-tools-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
}
